import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { defaultContent } from "@/data/defaultContent";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustStrip from "@/components/landing/TrustStrip";
import Services from "@/components/landing/Services";
import WhyUs from "@/components/landing/WhyUs";
import Sectors from "@/components/landing/Sectors";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

export default function LandingPage() {
  const { data } = useQuery({
    queryKey: ["site-content"],
    queryFn: async () => (await api.get("/content")).data,
  });

  const content = data && data.hero_title ? data : defaultContent;

  return (
    <div className="min-h-screen bg-[#050505] pb-16 sm:pb-0" data-testid="landing-page">
      <Header whatsappNumber={content.whatsapp_number} />
      <main>
        <Hero content={content} />
        <TrustStrip />
        <Services services={content.services} />
        <WhyUs points={content.why_us_points} />
        <Sectors sectors={content.sectors} />
        <ContactSection content={content} />
      </main>
      <Footer whatsappNumber={content.whatsapp_number} />
      <FloatingWhatsApp whatsappNumber={content.whatsapp_number} />
    </div>
  );
}
